export default {
  variant: {
    inventory: '',
    price: '',
    max_qty: 10
  }
}



// WEBPACK FOOTER //
// ./src/components/preview/store/state.js